module.exports = __webpack_public_path__ + "6bd9ff22aa79d2d635c240615d34a3f1.pdf";